import React from "react"
import { Link } from "gatsby"
import { Footer, Container, Content, Columns, Column } from "bloomer"

const MainFooter = () => {
  return (
    <Footer>
      <Container>
        <Columns>
          <Column isSize="1/3">
            <Content>
              <h3 className="is-size-5">EstrelaGuia ✦</h3>
              <p>
                Horóscopo, astrologia e oráculos em português, desde sempre com
                você: signos, mapa astral, tarot, baralho cigano, runas, cristais,
                anjos e numerologia.
              </p>
            </Content>
          </Column>
          <Column isSize="1/3">
            <Content>
              <h3 className="is-size-6">Explorar</h3>
              <p>
                <Link to="/horoscopo/">Horóscopo</Link><br />
                <Link to="/carta-do-dia/">Carta do Dia</Link><br />
                <Link to="/ranking-da-semana/">Ranking da Semana</Link><br />
                <Link to="/astrologia/compatibilidade-amorosa/">Compatibilidade Amorosa</Link><br />
                <Link to="/mapa-astral/">Mapa Astral</Link><br />
                <Link to="/ascendente/">Ascendente</Link><br />
                <Link to="/signo-chines/">Signo Chinês</Link><br />
                <Link to="/anjo-da-guarda/">Anjo da Guarda</Link><br />
                <Link to="/anjos/">Anjos</Link><br />
                <Link to="/artigos/">Artigos</Link><br />
                <Link to="/numerologia/">Numerologia</Link>
              </p>
            </Content>
          </Column>
          <Column isSize="1/3">
            <Content>
              <h3 className="is-size-6">Oráculos</h3>
              <p>
                <Link to="/jogo-de-tarot/">Jogo de Tarot</Link><br />
                <Link to="/oraculo/tarot-sim-ou-nao/">Tarot Sim ou Não</Link><br />
                <Link to="/oraculo/tarot/">Significado das cartas</Link><br />
                <Link to="/oraculo/mesa-real/">Mesa Real</Link><br />
                <Link to="/oraculo/baralho-cigano/">Baralho Cigano</Link><br />
                <Link to="/oraculo/runas/">Runas</Link><br />
                <Link to="/oraculo/cristais/">Cristais</Link>
              </p>
            </Content>
          </Column>
        </Columns>
        <Content isSize="small">
          <p>
            Conteúdo de entretenimento: horóscopo, tarot e oráculos são tradições
            simbólicas e não substituem orientação profissional.{" "}
            <Link to="/politica-de-privacidade/">Política de Privacidade e Termos</Link>
          </p>
          <p>© {new Date().getFullYear()} EstrelaGuia — estrelaguia.com.br</p>
        </Content>
        {/* Built by ZLI */}
        <Content>
          {/* <p>
            Made with{" "}
            <Icon hasTextColor="danger" className="fa fa-heart"></Icon> by{" "}
            <a
              href="https://zlicreative.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              ZLI Creative
            </a>
          </p> */}
        </Content>
        {/* Built with Gatsby, Bulma, and Bloomer */}
        <Content isSize="small">
          {/* <p>
            © {new Date().getFullYear()}, Built with
            {` `}
            <a
              href="https://www.gatsbyjs.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              Gatsby
            </a>
            ,{" "}
            <a
              href="https://bulma.io"
              target="_blank"
              rel="noopener noreferrer"
            >
              Bulma
            </a>{" "}
            and{" "}
            <a
              href="https://bloomer.js.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              Bloomer Components
            </a>{" "}
          </p> */}
        </Content>
      </Container>
    </Footer>
  )
}

export default MainFooter
